import React,{useEffect,useState, useRef} from "react";
import "./imageBanner.css";
import {getAWSUrl} from "../api/core";
import LazyImg from "../lazy/lazy";
import {BORDER} from "../../global";

const ImageBanner = (props) => {
  const [elemib,setElemIB] =useState([]);
         /* eslint-disable no-unused-vars */
  const [error,SetError]=useState(false);
  const [elemdisplayib,setElemDisplayIB] = useState(true);
       /* eslint-disable no-unused-vars */
  const [elemItemib,setItemIB] =useState([]);
       /* eslint-disable no-unused-vars */
  const [loading,isLoading]=useState(true);
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    const ImageDetail = async()=>
    {
    
      if (mounted.current) {
     /* eslint-disable no-unused-vars */
     setElemIB(props.tabbed?props.tabid:props.information);
         
     setElemDisplayIB(props.tabbed?props.tabid.devices[0].itemVisibility:props.information.devices[0].itemVisibility);
     setItemIB(props.tabbed?props.tabid.items:props.information.items);
     
      /* eslint-disable no-unused-vars */  
      }
     
    }
    
    ImageDetail();
    isLoading(false);

    return () => {
      mounted.current = false;
    };
    

},[props.information,props.match.params.AppId,props.tabid,props.tabbed])


if(elemdisplayib && !error && !loading && elemib.items!=null && elemib.items.length>0)
  {

    if(elemib.items[0].itemid.devices[0].itemVisibility)
    {
      return(
    
        <div className="container-fluid wrapper_fluid">
            <div className="row">
    
    <div className="gallery-list col-md-12 col-xs-12">
            <a href={elemib.items[0].itemid.pageType==="externalPage"?elemib.items[0].itemid.externalPage:elemib.items[0].itemid.pageType==="internalPage"?elemib.items[0].itemid.internalPage:elemib.items[0].itemid.pageType==="videoPage"?"/"+props.match.params.AppId+"/"+elemib.items[0].itemid.pageType+"/"+elemib.items[0].itemid.videoId:elemib.items[0].itemid.urlName!==""?"/"+props.match.params.AppId+"/"+elemib.items[0].itemid.urlName:elemib.items[0].itemid.pageType+"/"+elemib.items[0].itemid._id} className={BORDER?"image-grid":"image-grid no-border"} style={{display:"block"}}>
              <LazyImg className="img-responsive" src={elemib.items[0].itemid.bannerImage?getAWSUrl()+elemib.items[0].itemid.bannerImage.imagekey:"" } alt="banner" orient={"landscape"}/>
            </a>
          </div>
        </div>
    
        </div>
        );
    }
    else
    {
      return(<div className="none"></div>)
    }
   
  }
  else if(elemdisplayib && !error && loading)
  {
    return(<div style={{minHeight:'400px'}}>Banner</div>);
  }
  else
  {
    
    return(<div></div>);
  }
  

}

export default ImageBanner;




